import { createPresenceClient } from "../shared/presence-client.js";
import { mountStrip } from "../shared/strip.js";
import { createPack } from "./pack.js";
import { mountDeck } from "./deck.js";
import { mountLibrary } from "./library.js";
import { openEditor } from "./editor.js";
import { openShare } from "./share.js";
import { addCardsToDeck } from "./storage.js";
import { mountProse } from "../prose.js";

window.addEventListener("load", async () => {
  const presence = createPresenceClient();
  mountStrip(presence);

  const head = document.querySelector(".tc-head-section");
  if (head) mountProse(head, {});

  const packRoot = document.getElementById("pack-root");
  const deckRoot = document.getElementById("deck-root");
  const libRoot  = document.getElementById("library-root");
  const overlay  = document.getElementById("editor-overlay");

  const deck = await mountDeck(deckRoot);
  const lib = mountLibrary(libRoot, {
    onOpen: (id) =>
      openEditor({
        rootEl: overlay, compId: id,
        onClose: () => { lib.render(); deck.render(); },
        onShare: (state) => openShare(state, presence),
      }),
    onNew: () =>
      openEditor({
        rootEl: overlay, compId: null,
        onClose: () => { lib.render(); deck.render(); },
        onShare: (state) => openShare(state, presence),
      }),
  });

  createPack({
    rootEl: packRoot,
    presence,
    onOpened: (cards) => { addCardsToDeck(cards); deck.render(); },
  });

  deck.render();
  lib.render();

  presence.connect();
});
